import { showNotification } from "@mantine/notifications";
import { MedplumClient } from "@medplum/core";


import others from "../assets/img/others.svg";
import EpicSelect from "../assets/img/EpicPatint.svg";
import cernerSelecr from "../assets/img/CernerPatient.svg";
import aaathenaSelect from "../assets/img/AthenaPatient.svg";


const fetchAndFormatPatientList = async (medplum: MedplumClient, listQuery: string) => {
    const patientData = await medplum.searchResources("Patient", listQuery);
    const FormattedPatientData = patientData.map((patient) => {
        const containsCerner = patient?.identifier?.[0]?.type?.coding?.some(
            (coding) => coding.system?.includes("cerner")
        );
        const containsAthena = patient?.identifier?.some(
            (item) => item.system && item.system.includes("athena")
        );
        let ehrtype = "";
        if (
          patient?.identifier?.find(
            (id) => id.system === "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0"
          )
        ) {
          ehrtype = "EPIC";
        } else if (containsCerner) {
          ehrtype = "Cerner";
        } else if (containsAthena) {
          ehrtype = "Athena Health";
        } else {
          ehrtype = "Others";
        }
        let EHRIcon;
        switch (ehrtype) {
            case "EPIC":
                EHRIcon = (
                    <img
                        src={EpicSelect}
                        style={{
                            marginRight: "10px",
                            width: "30px",
                        }}
                        alt="EPIC"
                    />
                );
                break;
            case "Cerner":
                EHRIcon = (
                    <img
                        src={cernerSelecr}
                        style={{
                            marginRight: "10px",
                            width: "30px",
                        }}
                        alt="Cerner"
                    />
                );
                break;
            case "Athena Health":
                EHRIcon = (
                    <img
                        src={aaathenaSelect}
                        style={{
                            marginRight: "10px",
                            width: "30px",
                        }}
                        alt="Athena"
                    />
                );
                break;
            default:
                EHRIcon = (
                    <img
                        src={others}
                        style={{
                            marginRight: "10px",
                            width: "30px",
                        }}
                        alt="Others"
                    />
                );
        }
        return {
            label: getPatientName(patient.name),
            value: patient.id,
            ehr: ehrtype,
            icon: EHRIcon,
        };
    });

    return {FormattedPatientData, patientData};
}


const getPatientName = (patientData: any) => {
    let name = "--";
    if (patientData?.length > 0) {
        patientData.forEach((res: any) => {
            if ((res?.use === "official" || res?.use === "usual") && name === "--") {
                name = res?.text || res?.given.join(" ") + " " + res.family;
            }
        });
        if (name === "--")
            name = patientData[0]?.text || patientData[0]?.given || "--";
        if (typeof name !== "string") {
            name = String(name);
        }
    }
    return name;
}


export { fetchAndFormatPatientList, getPatientName };